import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Header = () => {
    return (
        <nav className="navbar navbar-expand-lg header-light bg-white navbar-light">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src="images/logo/aumyog_logo_without_name_trans.png" data-at2x="images/demo-startup-logo-white@2x.png" alt="" className="default-logo" />
                    <img src="images/logo/aumyog_logo_without_name_trans.png" data-at2x="images/demo-startup-logo-black@2x.png" alt="" className="alt-logo" />
                    <img src="images/logo/aumyog_logo_without_name_trans.png" data-at2x="images/demo-startup-logo-black@2x.png" alt="" className="mobile-logo" />
                </a>

                {/* Hamburger Toggler */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Collapsible Menu */}
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li class="nav-item"><a href="/" class="nav-link">Home</a></li>
                        <li class="nav-item"><a href="about" class="nav-link">About</a></li>
                        <li class="nav-item"><a href="level-1" class="nav-link">श्री मंत्र कार्यशाळा १</a></li>
                        <li class="nav-item"><a href="sadhanas" class="nav-link">Sadhanas</a></li>
                        <li class="nav-item"><a href="events" class="nav-link">Events</a></li>
                        <li class="nav-item"><a href="contact" class="nav-link">Contact</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
